import React from "react";
import { graphql } from "gatsby";

import WithI18next from "../../components/WithI18next";
import Layout from "../../components/Layout";

import ProjectDetailsArticleLayout from "../../layouts/ProjectDetailsArticleLayout";
import ListedCoinInfoCard from "../../components/CoinInfoComponents/ListedCoinInfoCard";
import { getCoinInsightLink } from "../../utils/coinInsight";

const NewCoinInfo = ({ data, pageContext, location, lang, t }) => {
  const coinInfo = data.coinInfoItem;

  const coinInsightLink = getCoinInsightLink(pageContext.lang, coinInfo.slug);

  const getCurrencies = () =>
    ({
      en: ["USD", "SGD"],
      au: ["AUD", "USDT"],
      th: ["THB"],
      id: ["IDR", "USDT"],
    }[lang.split("_")[0]]);

  return (
    <Layout title={coinInfo.seo.title} description={coinInfo.seo.metaDesc}>
      <ProjectDetailsArticleLayout
        coinInfo={coinInfo}
        currencies={getCurrencies()}
        currentUrl={location.href}
        coinInsightLink={coinInsightLink}
        t={t}
      >
        <h2 className="pt-5">Read more</h2>
        <div className="row">
          {data.otherCoinInfos.nodes.map(
            ({ slug, excerpt, acfCoinInfo }, i) => (
              <ListedCoinInfoCard
                key={`coin-info-read-more-${i}`}
                classNames="col-md-6 col-lg-3"
                linkTo={`/coin-info/${slug}/`}
                fullName={`${acfCoinInfo.ciHomeFullName} (${acfCoinInfo.ciTickerSymbol})`}
                featuredImageSharp={acfCoinInfo.ciHomeFeaturedImage.localFile}
                excerpt={excerpt}
              />
            )
          )}
        </div>
      </ProjectDetailsArticleLayout>
    </Layout>
  );
};

export default WithI18next()(NewCoinInfo);

export const query = graphql`
  query ($id: Int!, $wpLocale: String!, $wpGlobalConfig: String!) {
    coinInfoItem: wpNewCoinInfoItem(databaseId: { eq: $id }) {
      slug
      excerpt
      content
      seo {
        title
        metaDesc
      }
      categories {
        nodes {
          slug
        }
      }
      acfCoinInfo {
        ciHomeFullName
        ciTickerSymbol
        ciIcon {
          localFile {
            publicURL
          }
        }
        websiteLink
        whitepaperLink
        detailedRuleLink
      }
    }

    otherCoinInfos: allWpNewCoinInfoItem(
      limit: 4
      filter: {
        databaseId: { ne: $id }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
      }
    ) {
      nodes {
        slug
        excerpt
        acfCoinInfo {
          ciHomeFullName
          ciTickerSymbol
          ciHomeFeaturedImage {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 600, layout: CONSTRAINED)
              }
            }
          }
        }
      }
    }
  }
`;
